import React, { useEffect, useState, useContext } from "react";

import LocalizationContext from "../LocalizationContext";

import FYlogo from "../Shared/img/FY/logo_bianco.png";
import iconFacebook from "../Shared/img/FY/ico-facebook.svg";
import iconInstagram from "../Shared/img/FY/ico-instagram.svg";
import iconLinkedin from "../Shared/img/FY/ico-linkedin.svg";
import iconYoutube from "../Shared/img/FY/ico-youtube.svg";
import iconPinterest from "../Shared/img/FY/ico-pinterest.svg";
import iconTwitter from "../Shared/img/FY/ico-twitter.svg";

export const FooterFerrettiInfynito = (props) => {
    let currentYear = new Date().getFullYear();
    const localizationCtx = useContext(LocalizationContext);

    const urlPolicy = "https://www.ferretti-yachts.com/" + props.cultureCode + "/Policy";
    const urlCookies = "https://www.ferretti-yachts.com/" + props.cultureCode + "/Cookies";

    return (
        <footer>
            <div className="container py-5 text-dark-grey">
                <div className="row py-3">
                <div className="col-2 d-none d-lg-block"></div>
                    <div className="col-12 col-lg-4">
                        <a href="https://www.ferretti-yachts.com" target="_blank"><img src={FYlogo} alt="image" className="mw-200 d-table mx-auto" /></a>
                        <p className="text-center pt-5"><a href="https://www.ferrettigroup.com/" target="_blank">a Ferretti Group brand</a></p>
                    </div>
                    <div className="col-12 col-lg-4 mt-5 mt-lg-0">
                        <div className="row">
                            <div className="col-12">
                                <div className="text-center text-lg-end">
                                    <span className="d-inline-block border-bottom pb-4">
                                        <a href="https://www.facebook.com/FerrettiYachts.Official" className="me-3">
                                            <img src={iconFacebook} alt="" />
                                        </a>
                                        <a href="https://www.instagram.com/ferrettiyachts" className="me-3">
                                            <img src={iconInstagram} alt="" />
                                        </a>
                                        <a href="https://www.linkedin.com/company/ferretti-group" className="me-3">
                                            <img src={iconLinkedin} alt="" />
                                        </a>
                                        <a href="https://www.youtube.com/FerrettiOfficial" className="me-3">
                                            <img src={iconYoutube} alt="" />
                                        </a>
                                        <a href="https://pinterest.com/ferrettigroup/" className="me-3">
                                            <img src={iconPinterest} alt="" />
                                        </a>
                                        <a href="https://www.twitter.com/FerrettiGroup">
                                            <img src={iconTwitter} alt="" />
                                        </a>
                                    </span>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-2 d-none d-lg-block"></div>
                </div>
            </div>
            <div className="container-fluid py-3 bkg-bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <p className="text-center">

                            COPYRIGHT &copy; {currentYear} {localizationCtx.localizationData.footerRow1} <br />
                            {localizationCtx.localizationData.footerRow2} <br />
                                <a href={urlPolicy} target="_blank">{localizationCtx.localizationData.footerPolicy} </a>&nbsp;|&nbsp;<a href={urlCookies} target="_blank">{localizationCtx.localizationData.footerCookies} </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );

};

export default FooterFerrettiInfynito;